import { ProductType, UPGRADE_STEPS } from '@/lib/constants/maverick';
import { hasProductTypeInCartItemGroups } from '../cart.utils';
import type { CartButtonVariants } from './CartCTAButtons';
import { useGetCurrentPageMaverick } from '@/hooks/useGetCurrentPageMaverick';
import { useSiteStore } from '@/store/SiteStoreProvider';
import { useShallow } from 'zustand/react/shallow';
import {
  useSharedButtonLogic,
  type UseSharedButtonLogicReturn,
} from './useSharedButtonLogic';

export interface UseUpgradeFlowButtonLogicReturn
  extends UseSharedButtonLogicReturn {
  buttonsVariant: CartButtonVariants;
}

interface UseUpgradeFlowButtonLogicProps {
  buttonsVariant: CartButtonVariants;
  isUpcycleExperimentVariant?: boolean;
}

export function useUpgradeFlowButtonLogic({
  buttonsVariant,
  isUpcycleExperimentVariant,
}: UseUpgradeFlowButtonLogicProps): UseUpgradeFlowButtonLogicReturn {
  const { cart } = useSiteStore(
    useShallow((state) => ({
      cart: state.cart,
    })),
  );
  const page = useGetCurrentPageMaverick();
  const isUpgradeUpcyclePage = page === UPGRADE_STEPS.UPCYCLE;

  if (
    isUpgradeUpcyclePage &&
    (hasProductTypeInCartItemGroups(
      cart.cartItemGroups,
      ProductType.UPCYCLE_MEMBERSHIP,
    ) ||
      isUpcycleExperimentVariant)
  ) {
    buttonsVariant = 'control';
  }

  // Get shared button logic
  const sharedLogic = useSharedButtonLogic({
    isUpgradeFlow: true,
    buttonsVariant,
  });

  return {
    ...sharedLogic,
    buttonsVariant,
  };
}
